import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

const FEATURE_FLAG = gql`
  query OnboardingAccessFlag($key: String!) {
    featureFlag(key: $key) {
      enabled
    }
  }
`;

export function useOnboardingAccess() {
  const { data, loading } = useQuery(FEATURE_FLAG, {
    variables: { key: 'onboarding_access_control' },
  });

  const isFeatureEnabled = data?.featureFlag?.enabled ?? false;

  return {
    isBlocked: !isFeatureEnabled,
    isLoading: loading,
  };
}
